function SupportIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 18 18">
      <path id="BytesizeMessage" d="M2,4H19V16.24H10.5L5.643,21V16.24H2Z" transform="translate(-1.5 -3.5)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" />
    </svg>
  );
}

export default SupportIcon;
